/* RESPONSIBLE TEAM: team-data-foundations */
import AppstoreAppPackageBaseRoute from 'embercom/routes/base/appstore/app-package';

export default AppstoreAppPackageBaseRoute;
